/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FilesTree/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AllFilesActions from './AllFilesActions/index'
import Documents from './Documents/index'
import ImageSeries from './ImageSeries/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FilesTree({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'AllFilesActions'
  return (<React.Fragment
>
<div
  data-testid="FilesTree.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'AllFilesActions'}>
<AllFilesActions
  viewPath={`${viewPath}/AllFilesActions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Documents'}>
<Documents
  viewPath={`${viewPath}/Documents`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImageSeries'}>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}